import { __rest } from "tslib";
import React from "react";
import { View, Text, Image, StyleSheet } from "react-native";
import { PnmacText, PnmacCard, colors } from "pnmac-universal-components";
import { currencyFormatterWithoutSign } from '../../utils.js';
import moment from 'moment';
import { textStyle } from '../../v2/theme';
import { Platform } from 'react-native';
var EscrowAnalysisPaymentBreakdown = function (_a) {
  var matches = _a.matches,
    translations = _a.translations,
    props = __rest(_a, ["matches", "translations"]);
  var lookBackDataLatest = props.layout.escrowAnalysisLookBackData.length > 0 ? props.layout.escrowAnalysisLookBackData[0] : [];
  var TopAmountView = function (_a) {
    var _b = _a.paymentType,
      paymentType = _b === void 0 ? "Base Escrow" : _b,
      _c = _a.newMonthly,
      newMonthly = _c === void 0 ? false : _c;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
      style: [styles.headingStyle]
    }, /*#__PURE__*/React.createElement(View, {
      style: newMonthly == true ? [styles.newMonthlyBottomBoderStyle] : [styles.normalBottomBoderStyle]
    }, /*#__PURE__*/React.createElement(View, {
      style: newMonthly == true ? [{
        marginBottom: 10,
        paddingLeft: 10
      }] : [{
        marginBottom: 10
      }]
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.subTitleText]
    }, paymentType)))));
  };
  var SubHeadingView = function (_a) {
    var heading = _a.heading,
      amount = _a.amount,
      _b = _a.newMonthly,
      newMonthly = _b === void 0 ? false : _b;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
      style: newMonthly == true ? [styles.headingStyle, styles.newMonthlyBottomBoderStyle, styles.bottomSpacingStyle] : [styles.headingStyle, styles.normalBottomBoderStyle, styles.bottomSpacingStyle, matches.small ? null : null]
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, styles.subHeading2Style]
    }, heading), /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, newMonthly ? styles.subHeading31Style : styles.subHeading1Style]
    }, amount)));
  };
  var CalculateHeight = function () {
    var numberOfRows = 1;
    if ((lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyEscrowPayment_AmountChanged) != 0) {
      numberOfRows += 1;
    }
    if ((lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.insuranceLineItemsTotal_AmountChanged) != 0) {
      numberOfRows += 1;
    }
    if ((lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.miLineItemsTotal_AmountChanged) != 0) {
      numberOfRows += 1;
    }
    return numberOfRows == 1 ? 100 : numberOfRows == 2 ? 130 : numberOfRows == 3 ? 160 : 190;
  };
  var MonthlyEscrowAmountView = function () {
    var sectHeight = CalculateHeight();
    return /*#__PURE__*/React.createElement(View, {
      style: matches.small ? {
        paddingRight: 5
      } : styles.boxParentViewStyle
    }, /*#__PURE__*/React.createElement(TopAmountView, {
      paymentType: translations.EAPBaseEscrow
    }), /*#__PURE__*/React.createElement(View, {
      style: [matches.small ? styles.normalVeryBottomBoderStyle : {
        minHeight: sectHeight
      }]
    }, /*#__PURE__*/React.createElement(SubHeadingView, {
      heading: translations.EAPMonthlyEscrowAmount,
      amount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyEscrowPaymentAmount) != 0 ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyEscrowPaymentAmount) : "N/A"
    }), /*#__PURE__*/React.createElement(View, {
      style: [styles.bottomSpacingStyle]
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, styles.subHeading2Style, {
        flex: 5
      }]
    }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyEscrowPayment_AmountChanged) == 0 ? translations.EAPEscrowAmountUnchanged : (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyEscrowPayment_AmountChanged) > 0 ? translations.EAPEscrowAmountIncreased + " " : translations.EAPEscrowAmountDecreased + " "), (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyEscrowPayment_AmountChanged) != 0 ? /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, styles.itemTextStyle, {
        fontWeight: "bold",
        flex: 2,
        textAlign: 'left'
      }]
    }, currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyEscrowPayment_AmountChanged) || "N/A") : null), (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.insuranceLineItemsTotal_AmountChanged) != 0 ? /*#__PURE__*/React.createElement(View, {
      style: [{
        flexDirection: "row"
      }, styles.subHeading2Style]
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, {
        flex: 5
      }]
    }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.insuranceLineItemsTotal_AmountChanged) > 0 ? translations.EAPHazardInsuranceIncreased + " " : translations.EAPHazardInsuranceDecreased + " "), /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, styles.itemTextStyle, {
        flex: 2,
        textAlign: 'left'
      }]
    }, currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.insuranceLineItemsTotal_AmountChanged) || "N/A")) : null, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.taxLineItemsTotal_AmountChanged) != 0 ? /*#__PURE__*/React.createElement(View, {
      style: [{
        flexDirection: "row"
      }, styles.subHeading2Style]
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, {
        flex: 5
      }]
    }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.taxLineItemsTotal_AmountChanged) > 0 ? translations.EAPPropertyTaxesIncreased + " " : translations.EAPPropertyTaxesDecreased + " "), /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, styles.itemTextStyle, {
        flex: 2,
        textAlign: 'left'
      }]
    }, currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.taxLineItemsTotal_AmountChanged) || "N/A")) : null, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.miLineItemsTotal_AmountChanged) != 0 ? /*#__PURE__*/React.createElement(View, {
      style: [{
        flexDirection: "row"
      }, styles.subHeading2Style]
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, {
        flex: 5
      }]
    }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.miLineItemsTotal_AmountChanged) > 0 ? translations.EAPMortgageInsuranceIncreased + " " : translations.EAPMortgageInsuranceDecreased + " "), /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, styles.itemTextStyle, {
        flex: 2,
        textAlign: 'left'
      }]
    }, currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.miLineItemsTotal_AmountChanged) || "N/A")) : null))));
  };
  var ShortageAmountView = function () {
    var sectHeight = CalculateHeight();
    return /*#__PURE__*/React.createElement(View, {
      style: matches.small ? {
        paddingRight: 5
      } : [styles.boxParentViewStyle, {
        paddingRight: 5
      }]
    }, /*#__PURE__*/React.createElement(TopAmountView, {
      paymentType: translations.EAPAdditionalEscrow
    }), /*#__PURE__*/React.createElement(View, {
      style: [matches.small ? {} : {
        minHeight: sectHeight
      }]
    }, /*#__PURE__*/React.createElement(SubHeadingView, {
      heading: translations.EAPMonthlyReserveAndOrShortageAmount,
      amount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyShortageAndOrReserveAmount) ? "+ " + currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyShortageAndOrReserveAmount) : "N/A"
    }), /*#__PURE__*/React.createElement(View, {
      style: [styles.bottomSpacingStyle]
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, styles.subHeading2Style, {
        flex: 5
      }]
    }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyShortageAndOrReserve_AmountChanged) == 0 ? translations.EAPShortageAmountUnchanged : (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyShortageAndOrReserve_AmountChanged) > 0 ? translations.EAPShortageReserveAmountIncreased + " " : translations.EAPShortageReserveAmountDecreased + " "), (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyShortageAndOrReserve_AmountChanged) != 0 ? /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, styles.itemTextStyle, {
        fontWeight: "bold",
        flex: 2,
        textAlign: 'left'
      }]
    }, currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyShortageAndOrReserve_AmountChanged) || "N/A") : null), (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyShortage_AmountChanged) != 0 ? /*#__PURE__*/React.createElement(View, {
      style: [{
        flexDirection: "row"
      }, styles.subHeading2Style]
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, {
        flex: 5
      }]
    }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyShortage_AmountChanged) > 0 ? translations.EAPShortageAmountIncreased + " " : translations.EAPShortageAmountDecreased + " "), /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, styles.itemTextStyle, {
        flex: 2,
        textAlign: 'left'
      }]
    }, currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyShortage_AmountChanged) || "N/A")) : null, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyReserve_AmountChanged) != 0 ? /*#__PURE__*/React.createElement(View, {
      style: [{
        flexDirection: "row"
      }, styles.subHeading2Style]
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, {
        flex: 5
      }]
    }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyReserve_AmountChanged) > 0 ? translations.EAPReserveIncrease + " " : translations.EAPReserveDecrease + " "), /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, styles.itemTextStyle, {
        flex: 2,
        textAlign: 'left'
      }]
    }, currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.monthlyReserve_AmountChanged) || "N/A")) : null))));
  };
  var PrincipalAmountView = function () {
    var sectHeight = CalculateHeight();
    return /*#__PURE__*/React.createElement(View, {
      style: matches.small ? null : [styles.boxParentViewStyle, {
        paddingHorizontal: 5
      }]
    }, /*#__PURE__*/React.createElement(TopAmountView, {
      paymentType: translations.EAPPrincipalInterest
    }), /*#__PURE__*/React.createElement(View, {
      style: matches.small ? {} : {
        minHeight: sectHeight
      }
    }, /*#__PURE__*/React.createElement(SubHeadingView, {
      heading: translations.EAPPrincipalAndInterestAmount,
      amount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.principalAndInterestAmount) ? "+ " + currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.principalAndInterestAmount) : "N/A"
    })));
  };
  var NewMonthlyAmountView = function () {
    var sectHeight = CalculateHeight() + 2;
    var isPaymentSupplementVisible = (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.paymentSupplementAmount) != 0;
    return /*#__PURE__*/React.createElement(View, {
      style: matches.small ? null : styles.boxParentViewStyle
    }, /*#__PURE__*/React.createElement(TopAmountView, {
      paymentType: translations.EAPTotal,
      newMonthly: true
    }), /*#__PURE__*/React.createElement(View, {
      style: [{
        backgroundColor: '#F3D22F44',
        paddingLeft: 10
      }, matches.small ? {} : {
        minHeight: sectHeight
      }, styles.newMonthlyBottomBoderStyle]
    }, /*#__PURE__*/React.createElement(SubHeadingView, {
      heading: translations.EAPNewMonthlyPaymentAmount,
      amount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.newMonthlyEscrowPaymentAmount) ? "= " + currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.newMonthlyEscrowPaymentAmount) : "N/A",
      newMonthly: true
    }), /*#__PURE__*/React.createElement(View, {
      style: [styles.bottomSpacingStyle]
    }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.hudAssistanceBuyDownAmount) != 0 ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, styles.subHeading1Style, textStyle.defaultTextTitle]
    }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.hudAssistanceBuyDownAmount) > 0 ? translations.EAPHUDAssistanceBuyDownAmountIncreased : translations.EAPHUDAssistanceBuyDownAmountDecreased), /*#__PURE__*/React.createElement(View, {
      style: [{
        flexDirection: "row",
        marginTop: -10
      }, styles.subHeading2Style]
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, textStyle.defaultTextTitle]
    }, translations.EAPUDAssistanceBuyDownAmount + " "), /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, textStyle.defaultTextTitle]
    }, currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.hudAssistanceBuyDownAmount) || "N/A"))) : null, isPaymentSupplementVisible ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, styles.subHeading1Style, textStyle.defaultTextTitle]
    }, (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.paymentSupplementAmount) > 0 ? translations.EAPHUDAssistanceBuyDownAmountIncreased : translations.EAPHUDAssistanceBuyDownAmountDecreased), Platform.OS != "web" ? /*#__PURE__*/React.createElement(View, {
      style: [{
        flexDirection: "row",
        marginTop: -10
      }, styles.subHeading2Style]
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, textStyle.defaultTextTitle]
    }, translations.PSMonthlyReduction + " "), /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, textStyle.defaultTextTitle]
    }, currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.paymentSupplementAmount) || "N/A")) : /*#__PURE__*/React.createElement(View, {
      style: [styles.subHeading1Style]
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.formBody, textStyle.defaultTextTitle]
    }, translations.PSMonthlyReduction + " " + currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.paymentSupplementAmount) || "N/A"))) : null, /*#__PURE__*/React.createElement(PnmacText, {
      style: [styles.subHeading3tyle, textStyle.defaultTextTitle]
    }, translations.EffectiveDate, " ", (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.newPaymentEffectiveDate) ? moment(lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.newPaymentEffectiveDate).format("MMMM D, YYYY") : "N/A"))));
  };
  return /*#__PURE__*/React.createElement(View, {
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacCard, {
    nativeID: "eaFourBox",
    style: {
      backgroundColor: colors.white
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: [textStyle.formTitleSection, {
      paddingLeft: 10,
      marginTop: 10,
      marginBottom: 10
    }]
  }, translations.EAPPaymentBreakdown), /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: matches.small ? "column" : "row",
      paddingLeft: 10
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: [{
      flexDirection: matches.small ? "column" : "row",
      flex: 7
    }, styles.boxBoderStyle]
  }, /*#__PURE__*/React.createElement(MonthlyEscrowAmountView, null), /*#__PURE__*/React.createElement(ShortageAmountView, null)), /*#__PURE__*/React.createElement(View, {
    style: [{
      flex: 3
    }, matches.small ? {} : styles.normalVeryBottomBoderStyle]
  }, /*#__PURE__*/React.createElement(PrincipalAmountView, null)), /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 3
    }
  }, /*#__PURE__*/React.createElement(NewMonthlyAmountView, null)))));
};
export default EscrowAnalysisPaymentBreakdown;
var styles = StyleSheet.create({
  boxParentViewStyle: {
    flex: 1
  },
  headingStyle: {
    justifyContent: 'flex-start',
    marginTop: 10
  },
  bottomSpacingStyle: {
    marginBottom: 10
  },
  subHeading1Style: {
    justifyContent: 'flex-start',
    marginBottom: 10,
    color: '#117AAA'
  },
  subHeading2Style: {
    justifyContent: 'flex-start',
    marginBottom: 3,
    color: '#1B1B1B'
  },
  subHeading31Style: {
    justifyContent: 'flex-start',
    marginBottom: 10,
    color: '#1B1B1B'
  },
  boxBoderStyle: {
    paddingLeft: 5,
    marginBottom: 10,
    marginRight: 0,
    borderColor: '#c1c1c1',
    borderWidth: 1
  },
  normalBottomBoderStyle: {
    borderBottomColor: '#c1c1c1',
    borderBottomWidth: 1
  },
  normalVeryBottomBoderStyle: {
    borderBottomColor: '#c1c1c1',
    borderBottomWidth: 1,
    marginBottom: 10
  },
  newMonthlyBottomBoderStyle: {
    borderBottomColor: '#F3D22F',
    borderBottomWidth: 1
  },
  itemTextStyle: {
    color: colors.darkCyan,
    textAlign: "center",
    fontSize: 14
  }
});